/**
 * Types of entities that support filtering and selection
 */
export var HarmonyEntity;
(function (HarmonyEntity) {
    /**
     * Apps by name, description (which exists for 1P, but not AAD apps)
     */
    HarmonyEntity["App"] = "App";
    /**
     * Content by attributes
     */
    HarmonyEntity["Content"] = "Content";
    /**
     * Filter people by name, email
     */
    HarmonyEntity["People"] = "People";
    /**
     * Filter template by category
     */
    HarmonyEntity["Template"] = "Template";
    /**
     * Draft (used for help me create)
     */
    HarmonyEntity["Draft"] = "Draft";
})(HarmonyEntity || (HarmonyEntity = {}));
export var FilterBy;
(function (FilterBy) {
    /**
     * Tag to filter the content by
     */
    FilterBy["Tag"] = "Tag";
    /**
     * Explicity entity name or id. This must be an exact match.
     */
    FilterBy["Name"] = "Name";
    /**
     * Recent
     */
    FilterBy["Recent"] = "Recent";
    /**
     * Filter by FileType, like Word, Excel, PowerPoint or other start page types
     */
    FilterBy["FileType"] = "FileType";
    /**
     * Filter by name or email of the person who shared the content
     */
    FilterBy["SharedBy"] = "SharedBy";
    /**
     * Filter by activity like "Created by me" or "Modified by me"
     */
    FilterBy["Activity"] = "Activity";
    /**
     * Filter by date like "Yesterday", "Previous week"
     */
    FilterBy["Date"] = "Date";
})(FilterBy || (FilterBy = {}));
export var Select;
(function (Select) {
    Select["All"] = "All";
    Select["Top"] = "Top";
})(Select || (Select = {}));
//# sourceMappingURL=payloads.js.map